/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Sleep = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Sleep"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#5E1FF0"
      fillRule="evenodd"
      d="M12 3.667C12 2.747 12.746 2 13.667 2h6.666a1.667 1.667 0 0 1 1.302 2.708l-4.5 5.625h3.198a1.667 1.667 0 1 1 0 3.334h-6.666a1.667 1.667 0 0 1-1.302-2.708l4.5-5.626h-3.198c-.92 0-1.667-.746-1.667-1.666m-10 10C2 12.747 2.746 12 3.667 12h5A1.667 1.667 0 0 1 10 14.667l-3 4h1.667a1.667 1.667 0 1 1 0 3.333h-5a1.667 1.667 0 0 1-1.334-2.667l3-4H3.667c-.92 0-1.667-.746-1.667-1.666"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const SleepIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'sleep-icon'}
      icon={Sleep}
      {...props}
      size={size}
    />
  );
};
